<script lang="ts">
import { UiModule } from "@/store/modules/ui.store";
import { Component, Vue } from "vue-property-decorator";

/**
 * Class of the element a `v-navigation-drawer` scrolls, see `VNavigationDrawer.genContent`
 */
const DRAWER_CONTENT_CLASS = "v-navigation-drawer__content";

/**
 * Keeps the scroll offset of the navigation drawer when the drawer is rebuilt.
 *
 * The portal keeps its drawer while the user navigates - `Portal.vue` mounts the app shell above
 * the routed view - but a route that brings its own layout still replaces the shell, and the apps
 * that render their chrome per view rebuild the drawer on every navigation. Without this the
 * navigation would jump back to the top, away from the entry the user just selected.
 *
 * The offset is restored in `mounted`, before the browser paints the new drawer, so the navigation
 * stays where it was instead of scrolling into place.
 *
 * Expects the root element of the component to be a `v-navigation-drawer`.
 */
@Component({})
export default class NavigationDrawerScrollMixin extends Vue {
  mounted() {
    const content = this.getNavigationDrawerContent();

    if (content) {
      content.scrollTop = UiModule.navigationScrollTop;
    }
  }

  beforeDestroy() {
    const content = this.getNavigationDrawerContent();

    if (content) {
      UiModule.setNavigationScrollTop(content.scrollTop);
    }
  }

  /**
   * @returns the scrollable element of the drawer, if it is rendered
   */
  getNavigationDrawerContent(): HTMLElement | null {
    return (this.$el as HTMLElement)?.querySelector?.(`.${DRAWER_CONTENT_CLASS}`) ?? null;
  }
}
</script>
